const ENABLED_VALUE = 'true';

export enum FeatureToggle {
    GA_EVENT_LOGGING = 'enable_ga_event_logging',
}

export const isFeatureEnabled = (featureKey: FeatureToggle) => {
    return window.localStorage.getItem(featureKey) === ENABLED_VALUE;
};

export const isGaEventLoggingFeatureToggleEnabled = () => isFeatureEnabled(FeatureToggle.GA_EVENT_LOGGING);
